import React from 'react';
import { Phone, Mail, MapPin, ArrowUp } from 'lucide-react';
import './Footer.css';

function Footer() {
    // Robust scroll to top (works with fixed header)
    const handleBackToTop = (e) => {
        if (e) e.preventDefault();
        const homeElement = document.getElementById('home');
        if (homeElement) {
            homeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Column 1: Brand */}
                <div className="footer-col">
                    <img
                        src="/logo-horizontal.webp"
                        alt="CleanSweep Logo"
                        className="footer-logo"
                        onClick={handleBackToTop}
                        style={{ cursor: 'pointer' }}
                    />
                    <p className="footer-desc">
                        Leading the way in sustainable and compliant waste management solutions across Dubai.
                        Professional, reliable, and eco-friendly.
                    </p>
                </div>

                {/* Column 2: Quick Links */}
                <div className="footer-col">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><a href="#home" onClick={handleBackToTop}>Home</a></li>
                        <li><a href="#about-us">About Us</a></li>
                        <li><a href="#activities">Our Services</a></li>
                        <li><a href="#contact-us">Contact Us</a></li>
                    </ul>
                </div>

                {/* Column 3: Contact Info */}
                <div className="footer-col">
                    <h3>Contact Info</h3>
                    <div className="footer-contact">
                        <p><Phone size={16} /> <a href="tel:+971508364814">+971 50 8364814</a></p>
                        <p><Phone size={16} /> <a href="tel:+971508841182">+971 50 8841182</a></p>
                        <p><Mail size={16} /> <a href="mailto:info@cleansweep.ae">info@cleansweep.ae</a></p>
                        <p><MapPin size={16} /> Dubai, UAE</p>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} CleanSweep Waste Management. All Rights Reserved.</p>

                {/* Back to Top Button */}
                <button
                    className="back-to-top"
                    onClick={handleBackToTop}
                    title="Back to Top"
                    aria-label="Scroll to top"
                >
                    <ArrowUp size={20} />
                </button>
            </div>
        </footer>
    );
}

export default Footer;
